import { render, staticRenderFns } from "./BulkConfirmModal.vue?vue&type=template&id=32b918e1&"
import script from "./BulkConfirmModal.vue?vue&type=script&lang=js&"
export * from "./BulkConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b918e1')) {
      api.createRecord('32b918e1', component.options)
    } else {
      api.reload('32b918e1', component.options)
    }
    module.hot.accept("./BulkConfirmModal.vue?vue&type=template&id=32b918e1&", function () {
      api.rerender('32b918e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whitelist/components/BulkConfirmModal.vue"
export default component.exports